import React from "react";
import { useRouter } from "next/router";
import { useTranslations } from "@/TranslationContext";
import ListingsHelper from "@/utils/ListingsHelper";
import ListingsList from "./Lists";
import { ListingData } from "@/server/interfaces/ListingData";
import ListingItem from "./ListItem";

const SimilarItemsByLocation = ({
  listing,
  similarItems,
  fullLocation,
}: {
  listing: any;
  similarItems: any[];
  fullLocation: any;
}) => {
  const router = useRouter();
  const t = useTranslations();
  const { locale } = router;

  const ls = locale === "sw" ? "" : `/${locale}`;

  return (
    <div className="  rounded overflow-hidden">
      <div className=" space-y-8 ">
        <h3 className="text-2xl font-bold text-gray-700">
          Similar items by location
        </h3>
        <div className="gap-4 space-y-4 lg:columns-3  columns-2 ">
          {similarItems.map((Listing: ListingData, index: number) => (
            <div className="" key={index}>
              <ListingItem Listing={Listing} />
            </div>
          ))}
        </div>
      </div>

      <div className=" divide-y mt-10">
        <h4 className="p-3">
          <a
            className=" hover:text-green-600 font-bold  text-gray-600"
            href={`${ls}/${ListingsHelper.getLocationLinkForSimilarListingsByLocationId(
              listing,
              fullLocation.uuid
            )}`}
            title={fullLocation.full_name}
          >
            View all items at {fullLocation.full_name}{" "}
          </a>
        </h4>
        {fullLocation.level_2_parent && (
          <h4 className="p-3">
            <a
              className=" hover:text-green-600 font-bold  text-gray-600"
              href={`${ls}/${ListingsHelper.getLocationLinkForSimilarListingsByLocationId(
                listing,
                fullLocation.level_2_parent.uuid
              )}`}
              title={fullLocation.level_2_parent.full_name}
            >
              View all items at {fullLocation.level_2_parent.full_name}
            </a>
          </h4>
        )}
        {fullLocation.level_1_parent && (
          <h4 className="p-3">
            <a
              className=" hover:text-green-600 font-bold  text-gray-600"
              href={`${ls}/${ListingsHelper.getLocationLinkForSimilarListingsByLocationId(
                listing,
                fullLocation.level_1_parent.uuid
              )}`}
              title={fullLocation.level_1_parent.full_name}
            >
              View all items in {fullLocation.level_1_parent.full_name}
            </a>
          </h4>
        )}
      </div>
    </div>
  );
};

export default SimilarItemsByLocation;
